import { connect } from 'react-redux';
import applicantSubpages from 'modules/cm/pages/CaseDetailsPage/subPages/Applicant';
import { RootState } from 'store/configureStore';
import {
  getVulnerabilities,
  addNewVulnerability,
  deleteVulnerability,
  updateVulnerability,
} from 'modules/cm/Vulnerabilities/useCases';

const mapStateToProps = (state: RootState) => {
  return {
    applicantsVulnerabilities: state.vulnerabilities,
  };
};

const mapDispatchToProps = {
  getVulnerabilities,
  addNewVulnerability,
  deleteVulnerability,
  updateVulnerability,
};

export default connect(mapStateToProps, mapDispatchToProps)(applicantSubpages.Vulnerabilities);
